import {defineSlotRecipe} from '@chakra-ui/react3'

// only on-media needs an explicit PriceProduct variant to set on-media colors;
// default inherits color: text.primary via CSS cascade from the glass-pill root
export const PRICE_VARIANT_MAP = {
    'on-media': 'on-media'
}

export const CTA_SIZE_MAP = {
    'small|true': 'md',
    'large|true': 'lg',
    'small|false': 'lg',
    'large|false': 'lg'
}

export default defineSlotRecipe({
    slots: ['root', 'cta'],
    base: {
        root: {
            display: 'inline-flex',
            alignItems: 'center',
            paddingLeft: 'spacing-20',
            paddingRight: 'spacing-4',
            paddingTop: 'spacing-4',
            paddingBottom: 'spacing-4',
            borderRadius: 'round',
            backdropFilter: 'blur(8px)'
        },
        cta: {
            flex: '1 1 auto',
            minWidth: 0
        }
    },
    variants: {
        size: {
            small: {
                root: {
                    textStyle: 'body.small',
                    gap: 'spacing-12'
                }
            },
            large: {
                root: {
                    textStyle: 'body.medium',
                    gap: 'spacing-16'
                }
            }
        },
        hasPrice: {
            true: {},
            false: {
                root: {
                    display: 'contents'
                }
            }
        },
        layout: {
            inline: {
                cta: {
                    flex: '0 0 auto'
                }
            }
        },
        variant: {
            default: {
                root: {
                    bg: 'background.actions.ghost',
                    color: 'text.primary'
                }
            },
            'on-media': {
                root: {
                    bg: 'background.actions.on-media.ghost',
                    color: 'text.on-media.primary'
                },
                listPrice: {
                    bg: 'background.actions.on-media.ghost',
                    color: 'text.on-media.primary'
                }
            },
            // comparison table module: not part of price button group, but reused for the price display without providing CTA
            comparisonTable: {
                root: {
                    bg: 'transparent',
                    color: 'text.primary'
                }
            },
            // teaser module: not part of price button group, but reused for the price display without providing CTA
            plain: {
                root: {
                    bg: 'transparent',
                    paddingX: 0
                },
                container: {columnGap: 'spacing-4'},
                price: {
                    color: 'text.secondary',
                    textStyle: 'heading.medium'
                },
                listPrice: {
                    textStyle: 'body.small'
                }
            }
        }
    },
    defaultVariants: {
        size: 'large',
        hasPrice: true,
        variant: 'default'
    }
})
